export const buyers = [
  { name: "Dr. Alejandro Ruiz", country: "Mexico" },
  { name: "Dra. Valentina Gómez", country: "Colombia" },
  { name: "Dr. Javier Morales", country: "Spain" },
  { name: "Dra. Camila Fernández", country: "Argentina" },
  { name: "Dr. Sebastián Rojas", country: "Chile" },
  { name: "Dra. Lucía Herrera", country: "Peru" },
  { name: "Dr. Mateo Castillo", country: "Ecuador" },
  { name: "Dra. Daniela Vargas", country: "Costa Rica" },
  { name: "Dr. Andrés Pérez", country: "Dominican Republic" },
  { name: "Dra. Mariana Torres", country: "Uruguay" },
  { name: "Dr. Diego Navarro", country: "Venezuela" },
  { name: "Dra. Sofía Ramírez", country: "Panama" },
  { name: "Dr. Gabriel Ortiz", country: "Puerto Rico" },
  { name: "Dra. Isabel Mendoza", country: "Guatemala" },
  { name: "Dr. Tomás Aguilar", country: "Paraguay" },
  { name: "Dra. Paula Jiménez", country: "Bolivia" },
];
